export interface ITaskCard {
  guid: string;
  title: string;
  description: string | null;
  priority: 'high' | 'medium' | 'low';
  status: 'unassigned' | 'assigned' | 'completed';
  taskType: 'outbound_call' | 'inbound_call' | 'sms' | null;
  quickNotes: string | null;
  reportedByGuid: string;
  reportedByName: string | null;
  assignedToGuid: string | null;
  assignedToName: string | null;
  completedByGuid: string | null;
  completedByName: string | null;
  createdAt: string;
  updatedAt: string | null;
  assignedAt: string | null;
  completedAt: string | null;
}

export type DisplayStatus =
  | 'open'
  | 'assigned_to_me'
  | 'assigned_to_other'
  | 'completed';

export interface ITasksResponse {
  tasks: {
    pending: ITaskCard[];
    completed: ITaskCard[];
  };
  summary: {
    pendingCount: number;
    completedCount: number;
  };
}

export type TaskType = 'outbound_call' | 'inbound_call' | 'sms' | null;
export type Priority = 'high' | 'medium' | 'low';

export interface ITaskFormValues {
  title: string;
  priority: Priority;
  description: string | null;
  taskType: TaskType;
}

export interface ICreateTaskPayload {
  patientGuid: string;
  title: string;
  priority: Priority;
  description: string | null;
  taskType: TaskType;
}

export interface IUpdateTaskPayload {
  title: string;
  priority: Priority;
  description: string | null;
  taskType: TaskType;
}

export interface IUnassignTaskPayload {
  returnNote: string;
}

export type TaskApiError = {
  status?: number;
  response?: { data?: { message?: string } };
};

export const canEditTask = (task: ITaskCard, userGuid: string): boolean =>
  task.reportedByGuid === userGuid && task.status === 'unassigned';
